module.exports = __webpack_public_path__ + "static/media/worker-img.9d61a9a3.svg";